<template>
  <div v-show="noData == false" class="GisMapBackground" id="container" @click="handleClick"></div>
  <div v-show="noData == true" class="noKey" @click="handleClick">请输入正确的key</div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import Bigdata from '../../../apis/Bigdata';
export default {
  name: 'GisMapBackground',
  props: {
    /* 等比缩放需要使用ProjectInfo
     ProjectInfo.ScreenRatio: {
        w_Ratio: 100,  单位%   宽度缩放比
        h_Ratio: 100,  单位%   高度缩放比
      },
    */
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      // gisBackground: true,
      noData: false,
      mywpoint: null, // 点位
      mywinmap: null, // 热力
      mapType: 9, // 地图类型
      mapBasicSetting: null, // 地图基本设置
      vatchvalue: '',
      mykey: '',
      gisStyle: '',
      pointList1: [],
      mapevent: '',
      mapeventdata: {},
    };
  },
  computed: {
    ...mapState({
      // 视频
      monitorList: state => state.monitorList,
      // 点位
      pointList: state => state.pointList,
      // 热力图
      heatMapLngLat: state => state.heatMapLngLat,
      heatMapList: state => state.heatMapList,
      // 当前点位 index 值
      currentMonitor: state => state.currentMonitor,
      // 热力图 当前点位 index 值
      currentheatmap: state => state.currentheatmap,
    }),
  },
  create() {},
  mounted() {
    this.mykey = this.Configuration.propertyData.MapKey.value;
    // this.gisStyle = this.Configuration.propertyData.MapGisStyle.value.gisStyleName;
    this.gisStyle = this.Configuration.propertyData?.mapMode?.value;

    // let that = this;
    window.winMapEvent = (event, data) => {
      console.log(event, data, 'event, data');
      if (event === 'onFail') {
        this.noData = true;
      } else {
        this.noData = false;
      }
    };

    this.mapType = this.Configuration.propertyData.mapType.value;

    this.mapBasicSetting = this.Configuration.propertyData.mapBasicSetting.value;
    this.vatchvalue = this.pointList.SwitchValue;

    // setTimeout(() => {
    this.$nextTick(() => {
      this.initMap();
    });

    // }, 1000);
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (nV) {
        if (nV) {
          this.gisStyle = nV.propertyData.mapMode.value;

          this.mapType = nV.propertyData.mapType.value;
          // this.initMap();
          setTimeout(() => {
            if (!this.noData) {
              // this.pointVideoPoint(this.pointList1);
            }
          }, 2000);
        }
      },
    },
    // 当前点位 视频
    currentMonitor: {
      handler: function (nV) {
        this.mapClick(nV);
      },
    },
    // 当前热力 经纬度
    currentheatmap: {
      handler: function (nV) {
        this.heatCoodChange2(nV);
      },
    },
    heatMapList: {
      handler: function (list) {
        setTimeout(() => {
          this.mywpoint.moveMapContor(list[1], list[2]);
        }, 1000);

        // console.log(list, '4535345345345');
      },
    },
    // 热力图列表
    heatMapLngLat: {
      handler: function (nV) {
        setTimeout(() => {
          if (nV) {
            console.log(nV, '热力图列表');
            // 清除 方法
            this.mywpoint.mapclearAll();
            this.mywpoint.clearMarker();
            this.pointHeatMap(nV);
          }
        }, 1000);
      },
      deep: true,
    },
    // 点位 视频 列表
    pointList: {
      handler: function (nV) {
        setTimeout(() => {
          this.vatchvalue = nV.SwitchValue;
          if (nV) {
            // 清除 方法
            this.mywpoint.clearMarker();
            this.pointList1 = nV;
            console.log(nV, '点位 视频 列表');
            this.pointVideoPoint(nV);
          }
        }, 1000);
      },
      deep: true,
    },
  },
  methods: {
    // 初始化地图
    initMap() {
      this.mywpoint = null;
      let map = document.getElementById('GisMapBackground');
      console.log('map', map);
      this.mywpoint = new winMap('container', {
        style: this.gisStyle, // 地图风格
        maptype: this.mapType.maptype.toString(),
        key: this.mykey,
        // key: 'WKvseQPCaNwRbBDnLJtnm',
        maplon: this.mapBasicSetting.coordinate.lng,
        maplat: this.mapBasicSetting.coordinate.lat,
        level: this.mapBasicSetting.zoom + '',
        http_server: Bigdata.MapUrl,
        jwt: localStorage.getItem('_t'),
      });
    },
    // 地图点击
    handleClick(e) {
      e.stopPropagation();
      console.log(e, 'set_CurrentConfigration');
      this.$store.commit('set_CurrentConfigration', this.Configuration);
      this.$store.commit('set_ContextMenu', {
        isOpen: false,
      });
    },
    // 点位 视频 弹框
    mapClick(index) {
      this.mywpoint.clickMarker(this.vatchvalue, Number(index));
      // console.log(this.mywpoint, '647674867867');
    },
    // 热力中心点
    heatCoodChange2(road) {
      console.log('移动2', road);
      // this.mywpoint.moveMapContor('114.99982', '25.85533');
      this.mywpoint.moveMapContor(road[0].latitude, road[0].longitude);
    },
    // 热力数据
    pointHeatMap(list) {
      console.log('热力数据', list);

      // this.mywpoint.moveMapContor('114.99982', '25.85533');
      this.mywpoint.moveMapContor(list[0][0][0], list[0][0][1]);
      let heatdata = [];
      list[1].forEach(element => {
        heatdata.push([element.lng, element.lat, element.count]);
      });
      this.mywpoint.openHeatmap(heatdata, 500, 30);
    },
    // 点位 视频 标点
    pointVideoPoint(list) {
      console.log(list, 'xbxdbfbbfbffbfb');
      if (this.vatchvalue == 'point') {
        this.mywpoint.markerlist(list.Video, {
          iconConfig: '30,36,30,36',
          iconPath: '/guangbod.svg',
          isiconPath: '',
          groupName: this.vatchvalue,
          // infowindowStartIndex: 0,
          infowindowType: '7',
          infowindowHeight: '130px',
          infowindowWidth: '340px',
        });
      } else if (this.vatchvalue == 'video') {
        this.mywpoint.markerlist(list.Video, {
          groupName: this.vatchvalue,
          iconConfig: '40,45,24,40',
          // infowindowStartIndex: 0,
          infowindowType: '6',
          infowindowHeight: '360px',
          infowindowWidth: '480px',
          infowindowtop: '0.0024',
        });
      }
    },
  },
  Configuration: {
    componentTitle: '地图背景',
    componentName: 'GisMapBackground',
    componentOverViewImg: './img/backgrounds/MapBackground.png',
    id: 'GisMapBackground',
    style: {
      backgroundColor: '#19242D',
    },
    propertyData: {
      mapBasicSetting: {
        value: {
          coordinate: {
            lng: '114.99982',
            lat: '25.85533',
          },
          zoom: 15,
          is3dMap: false,
        },
        propertyComponentName: 'mapBasicSetting',
        lable: '地图基本设置',
      },
      mapType: {
        value: {
          maptype: '9',
        },
        propertyComponentName: 'mapType',
        lable: '地图类型',
      },
      // mapPopupData: {
      //   propertyComponentName: 'MapPopup',
      //   value: {
      //     borderComponentName: 'point',
      //   },
      // },
      MapKey: {
        propertyComponentName: 'MapKeyConfiger',
        value: 'WKvseQPCaNwRbBDnLJtnm',
      },
      // MapGisStyle: {
      //   propertyComponentName: 'MapStyleConfiger',
      //   value: {
      //     gisStyleName: '0',
      //   },
      // },
      mapMode: {
        select: [
          {
            label: '默认地图',
            value: '',
          },
          {
            label: '卫星地图',
            value: '4',
          },
        ],
        value: '',
        propertyComponentName: 'GeneralSelect',
        lable: '地图模式',
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.GisMapBackground {
  height: 100%;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.noKey {
  width: 100%;
  height: 100%;
  font-size: 16px;
  color: aliceblue;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #20212b;
}

.mapbackground {
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: '微软雅黑';
}

:deep().jqsbInfoBgleft {
  img {
    // width: 111px !important;
    // height: 114px !important;
    max-width: none;
  }
}

:deep().wzks_scenicImg2 {
  width: 100% !important;
}
</style>
